import { root } from "@shared/utils";
import React from "react";
import { FormattedMessage } from "react-intl";
import InnerModal from "react-modal";

import AuthForm from "../Form/AuthForm";

const customStyles = {
  overlay: {
    zIndex: 99999,
    backgroundColor: "rgba(0,0,0, 0.5)",
  },
};

export const Modal = ({ close, showModal, onAuth, loading, error }) => {
  return (
    <InnerModal
      isOpen={showModal}
      contentLabel="User Modal"
      style={customStyles}
      parentSelector={() => document.getElementById("mainSection")}
      onRequestClose={close}
      className="overlay"
      appElement={root}
    >
      <div className="overlay">
        <div className="scrollarea">
          <div className="scrollarea__inner">
            <div className="scrollarea__content">
              <div className="modal modal_slide_down modal_login">
                <div className="modal__close ico ico-close" onClick={close} />
                <FormattedMessage id="boilerplate.components.Popup.LoginModal.Title">
                  {(message) => <b className="modal__title">{message}</b>}
                </FormattedMessage>
                <AuthForm
                  onAuthEnter={onAuth}
                  show={showModal}
                  loading={loading}
                  errorMessage={error}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </InnerModal>
  );
};

export default Modal;
